module.exports = __webpack_public_path__ + "img/wifi.062870ce.svg";